export const RT_EVENT_TYPE = {
  ACTIVITY: 'Activity',
  VISITOR_MERGE: 'VisitorMerge'
};



// WEBPACK FOOTER //
// ./chat-app/constants/rt-event-type.js